import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '../../../api';
// 1. The "Library" function (CORRECTED for native fetch)
const handleSaveDoc = async ({ rowData, projectId, section }) => {
  // Strip UI-only meta before sending to backend
  const { meta, ...cleanRowData } = rowData; 

  return await apiRequest(`/api/doc/update`, {
    method: 'POST',
    body: JSON.stringify({
      ...cleanRowData,
      projectId,
      section
    })
  });
};




export const useDocSave = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: handleSaveDoc,
    onSuccess: (data, variables) => {
      // ⚡ Invalidate the table query so it re-fetches the fresh data from DB
      queryClient.invalidateQueries({ 
        queryKey: ['doc', variables.projectId, variables.section] 
      });
      console.log("Doc updated and UI refreshed!");
    },
    onError: (error) => {
      console.error("Failed to consume doc:", error);
    }
  });
};
